import { type PrimeVueConfiguration } from 'primevue/config'
import { BackbarStylingPreset } from '@/config/primevuestyle.config'
import passthroughConfig from './primevue.passthrough.js'

const primevueConfig: PrimeVueConfiguration = {
  ripple: false,
  locale: {
    dayNamesMin: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    monthNames: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ],
    monthNamesShort: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ],
    fileSizeTypes: ['Bytes', 'KB', 'MB', 'GB', 'TB']
  },
  theme: {
    preset: BackbarStylingPreset,
    options: {
      darkModeSelector: '.backbar-dark-mode'
    }
  },
  unstyled: false,
  pt: passthroughConfig
}

export default primevueConfig
